import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
// @ts-ignore
import { dependentSelectsCustonOnChange } from 'shared/newFormElements'
import { getCityList } from '../../../selectors'
import { convertUnicodeToLatin } from '../../../../../store/utility'
import { actionTypes, FORM_NAME } from '../../../constants'

const mapStateToProps = (state) => {
  const selector = formValueSelector(FORM_NAME)

  return {
    officialAddress: selector(state, 'Address'),
    officialAddressCity: selector(state, 'CityID'),
    legalCountry: selector(state, 'CountryID'),
    cityList: getCityList(state),
  }
}

const mapDispatchToProps = (dispatch, { selects }) => ({
  copyAddressFromOfficialAddress: async (address, city, country, list) => {
    const translatedAddress = await dispatch(convertUnicodeToLatin(address))
    const cities = list['CityIDList']

    dispatch({ type: actionTypes.UPDATE_CITIES_LIST, payload: { cities, fieldName: 'CityBusID' } })

    dispatch(change(FORM_NAME, 'CountryBusID', country))
    dispatch(change(FORM_NAME, 'AddressBus', address))
    dispatch(change(FORM_NAME, 'AddressBus_ALT', translatedAddress?.payload))
    dispatch(change(FORM_NAME, 'CityBusID', city))

    const flags = {
      modifies: {
        modifier: 'CityBusID',
        modifierAlias: 'CityID',
        field: { DistrictBusID: selects.District },
        dependent: {
          modifier: 'DistrictBusID',
          modifierAlias: 'DistrictID',
          field: { ZoneBusID: selects.Zone },
          form: FORM_NAME,
        },
        form: FORM_NAME,
      },
    }

    dependentSelectsCustonOnChange(city, dispatch, flags)
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,

  copyAddressFromOfficialAddress: () =>
    dispatchProps.copyAddressFromOfficialAddress(
      stateProps.officialAddress,
      stateProps.officialAddressCity,
      stateProps.legalCountry,
      stateProps.cityList,
    ),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)
